// ----------------------------------------------------------------------
// <copyright file='Izenda.ReportViewerFilters.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import { observer, propTypes as MobxPropTypes } from 'mobx-react';
import { SWITCH_TO_PREVIEW, SWITCH_TO_CONFIGURATION } from 'logic/data/Izenda.ReportBodyConstants';
import DashboardConstants from 'logic/data/Izenda.DashboardConstants';
import classnames from 'classnames';
import { isNil } from 'lodash/fp';
const FlipButton = observer(
  ({
    dashboardPart,
    dashboardPart: { isBackSide, reportPart, type },
    dashboardDetail,
    dashboardDetail: { switchDashboardPartSide },
    showLabel
  }) => {
    const flipIcon = isBackSide
      ? { className: 'icon-flip-front', tooltip: SWITCH_TO_PREVIEW }
      : { className: 'icon-flip-back', tooltip: SWITCH_TO_CONFIGURATION };

    const isDashboardText = type === DashboardConstants.TILE_TYPE.text.type;
    const flipClass = classnames(
      { 'disabled-elm': isNil(reportPart) && !isDashboardText },
      { btn: !isNil(reportPart) || isDashboardText }
    );

    return (
      <a
        className={flipClass}
        title={flipIcon.tooltip}
        onClick={switchDashboardPartSide.bind(dashboardDetail, dashboardPart, null)}
      >
        <i className={flipIcon.className} />
        {showLabel && <span>{flipIcon.tooltip}</span>}
      </a>
    );
  }
);

FlipButton.propTypes = {
  dashboardPart: MobxPropTypes.observableObject.isRequired,
  dashboardDetail: MobxPropTypes.observableObject.isRequired
};

export default FlipButton;



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Header/Izenda.FlipButton.js